import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import { UITypes } from "types"

interface Props {
  cell?: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
  status?: string
}

const StatusText = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  font-size: 14px;
`

export const ContractorStatus = ({ cell, status }: Props) => {
  const options = useAppSelector(state => state.tempData.contractorAccountStatusOptions) || []
  const statusValue = cell?.getValue().value ? String(cell.getValue().value) : status || ""

  const statusOption = options.find(option => option.value === statusValue)

  if (!statusOption) {
    return null
  }

  return <StatusText color={statusOption.color || "#64748b"}>{statusOption.label}</StatusText>
}
